import { FC, ComponentProps } from 'react';
import cn from 'classnames';
import { IFeatureBase } from 'mod/featureV2/interface';
import { FeatureSubtitle } from 'mod/featureV2/FeatureSuttitle';
import { FeatureTitle } from 'mod/featureV2/FeatureTitle';
import { FeatureDescription } from 'mod/featureV2/FeatureDescription';
import { useFeatureContext } from 'mod/featureV2/useFeatureContext';

export type IFeatureHeaderProps = ComponentProps<'div'> & {
    feature?: IFeatureBase;
    align?: Globals.Align;
};

export const FeatureHeader: FC<IFeatureHeaderProps> = props => {
    const { header = {} } = useFeatureContext();
    const { fadeUp = false } = header;
    const {
        className,
        align: propsAlign,
        feature
    } = props;

    const {
        subtitle,
        title,
        description,
        theme,
    } = feature || {};

    const {
        headerAlign,
        headerClassName = 'g-wrapper',
    } = theme || {};

    const align = propsAlign || headerAlign;
    const animateProps = fadeUp ? {
        'data-aos': 'fade-up',
        'data-aos-once': true
    } : null;

    return !subtitle && !title && !description ? null : (
        <div
            className={cn(
                'g-feature-header',
                className,
                headerClassName,
                align ? `text-${align}` : ''
            )}
            {...animateProps}
        >
            <FeatureSubtitle feature={feature}/>
            <FeatureTitle feature={feature}/>
            <FeatureDescription feature={feature}/>
        </div>
    )
};
